<template>
	<div id="crypto">
		<imageUSDT />
		<div class="crypto_main" v-show="!showBind">
			<div class="czTable">
				<!-- <div class="notice">
					<span class="iconfont">&#xe6df;</span>添加或修改绑定的银行卡，需要1小时后才能进行提现。
				</div> -->
				<el-table :data="tableData" border style="width: 100%">
					<!-- 判断有没有虛擬錢包的时候 显示 -->
					<div class="none_card" v-show="!isBind && lockedState == false" slot="empty">
						<div class="none_card_box">
							<span style="margin-right: 10px">您暂未绑定虚拟/数字钱包，点击</span>
							<el-button type="primary" class="blue" @click="addBankCart">立即绑定</el-button>
						</div>
					</div>
					<el-table-column prop="BankName" label="錢包類型" width="200" align="center" />
					<el-table-column prop="NameNum" label="錢包地址" width="360" align="center" />
					<el-table-column prop="CreateTime" label="日期" align="center" />
				</el-table>
			</div>

			<div class="bottom" v-if="isBind || lockedState == true" v-show="bindTipsShow">
				<div v-if="lockedState == false" class="bottom_top">
					<div class="tips_bind"></div>
					<p class="bottom_ts_text">{{ bindTips }}</p>
					<span class="blue" v-if="tableData.length < 10" @click="addBankCart">添加虚拟/数字钱包</span>
				</div>
				<div v-else class="tips lock">
					<div class="tips_bind"></div>
					<p class="bottom_ts_text">{{ bindTips }}</p>
					<span class="bottom_ts_text" style="margin-left: 10px"
						><a class="blue" :href="kfUrl" target="_blank">已锁定，点击联繫客服解锁</a></span
					>
				</div>
				<i class="el-icon-close oranges" @click="bindTipsShow = false"></i>
			</div>
			<div class="crypto_top">
				<div class="wxts_text">
					<p class="wxts">温馨提示：</p>
					<p class="list">1、最多只能添加10张银行卡或虚拟/数字钱包。</p>
					<p class="list">2、如需修改或删除虚拟/数字钱包请联系客服人员。</p>
				</div>
			</div>
		</div>
		<!-- 绑定虛擬錢包 -->
		<div class="bindCart" v-show="showBind">
			<el-form ref="form" :model="form" label-width="150px">
				<el-form-item label="錢包類型">
					<el-select v-model="form.DwId" placeholder="请选择">
						<el-option v-for="item in bankInfo" :key="item.DwId" :label="item.Name" :value="item.DwId" />
					</el-select>
				</el-form-item>
				<el-form-item label="錢包地址">
					<el-input v-model.trim="form.BankNumber" />
				</el-form-item>
				<el-form-item label="资金密码">
					<el-input v-model.trim="form.SafetyPassWord" type="password" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary btn_color" @click="onSubmit">立即添加</el-button>
					<el-button @click="onCancel">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 完善姓名 -->
		<el-dialog title="提示" :visible.sync="dialogVisible">
			<div class="warning_img">
				<img src="@/static/img/zjzh/warning.webp" style="width: 54px; height: 52px" alt="" />
			</div>
			<div style="text-align: center">您尚未设置真实姓名，请设置</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="goBindCart">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
import imageUSDT from "@/components/common/imageUSDT.vue";
import { SysKey } from "../../util/sysconfig";
export default {
	components: {
		imageUSDT,
	},
	name: "crypto",
	data() {
		return {
			bindTipsShow: true,
			dialogVisible: false,
			walletCount: 0,
			tableData: [],
			//隐藏或显示绑定一张卡还是为绑定卡
			isBind: false,
			//银行列表信息
			bankInfo: [],
			//显示隐藏绑定虛擬錢包
			showBind: false,
			form: {
				Bid: 0,
				DwId: "",
				BankNumber: "",
				SafetyPassWord: "",
			},
			userInfo: {},
			kfUrl: SysKey("KfCenterUrl").SysValue,
		};
	},
	computed: {
		bindTips() {
			return `您已经绑定${this.tableData.length}个虚拟/数字钱包`;
		},
		lockedState() {
			return this.$store.state.bankIslocking;
		},
	},
	created() {
		this.getBankList();
		this.getUserWalletCount();
		this.getAllInfo();
		this.$store.dispatch("getBankIslocking");
	},
	methods: {
		//获取绑定虛擬錢包接口
		getBankList() {
			var url = "api/Bank/GetUserCryptoWalletList";
			getAjax(url).then(data => {
				if (data.IsSucess) {
					this.tableData = data.Data.map(item => ({
						...item,
						NameNum: `${item.BankName} (${item.BankNumber})`,
					}));
					//如果有数据就给他增加一个字段为地址address
					if (this.tableData.length > 0) {
						this.isBind = true;
						for (var i = 0, length = this.tableData.length; i < length; i++) {
							this.tableData[i].address = this.tableData[i].BankProvince + "--" + this.tableData[i].BankCity;
						}
					} else {
						this.isBind = false;
					}
				}
			});
		},
		//添加虛擬錢包
		addBankCart() {
			if (this.walletCount >= 10) {
				return this.$message.error("最多只能添加10张银行卡或虚拟/数字钱包");
			}
			if (!this.userInfo.FullName) {
				this.dialogVisible = true;
			} else {
				this.showBind = true;
			}
		},
		//立即创建
		onSubmit() {
			let url = "/api/Bank/AddUserBankInfo";
			const loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
			postAjax(url, this.form)
				.then(data => {
					if (data.IsSucess) {
						this.getBankList();
						this.getUserWalletCount();
						this.onCancel();
					} else {
						this.$message.error(data.Message);
						this.onCancel();
					}
				})
				.catch(err => {
					console.log("error", err);
				})
				.finally(() => {
					loading.close();
				});
		},
		onCancel() {
			this.showBind = false;
			this.form = {
				Bid: 0,
				DwId: "",
				BankNumber: "",
				SafetyPassWord: "",
			};
		},
		goBindCart() {
			this.$emit("routerChange", "grzl");
			this.dialogVisible = false;
		},
		getUserWalletCount() {
			let url = "/api/Bank/GetUserWalletCount"; // 取得卡片綁定數量
			getAjax(url)
				.then(data => {
					if (data.IsSucess) {
						this.walletCount = data.Data;
					} else {
						this.$message.error(data.Message);
					}
				})
				.catch(err => {
					console.log("error", err);
				});
		},
		getAllInfo() {
			let promises = [
				postAjax("api/Cash/GetDrawChannel"), //获取银行列表
				postAjax("Api/User/GetUserInfo"), // 得到用户信息方法
			];

			Promise.all(promises)
				.then(items => {
					if (items[0].IsSucess) {
						this.bankInfo = items[0].Data.filter(item => item.IsCryptoWallet);
					}
					if (items[1].IsSucess) {
						this.userInfo = items[1].Data;
						if (!this.userInfo.FullName) {
							this.dialogVisible = true;
						}
					}
				})
				.catch(() => {
					this.$message.error("网络异常，请刷新后再试");
				});
		},
	},
};
</script>
<style lang="scss">
.crypto_main {
	padding: 20px 20px 20px 0;
}

.crypto_main .czTable {
	margin-top: 0;
}

#crypto input::placeholder {
	color: #606266;
}

#crypto .name {
	font-size: 16px;
	font-weight: bold;
	color: black;
	line-height: 24px;
	margin-top: 20px;
}

#crypto .yue {
	font-size: 16px;
	font-weight: normal;
	color: #00772e;
	line-height: 24px;
}

/*右边*/
/*第二排*/
.two_box {
	width: calc(100%);
	padding: 0 20px;
	background-color: white;
}

.left_two_box {
	padding: 40px 20px;
	max-height: 240px;
}

/*表格抬头*/
.ykhgl_top_left .name,
.ykhgl_top_left .list {
	text-align: left;
	margin-left: 20px;
}

.ykhgl_top_left .name {
	color: #000000;
	font-size: 16px;
	line-height: 24px;
}

.ykhgl_top_left .list {
	color: #e9a400;
	font-size: 14px;
	line-height: 28px;
}

.ykhgl_top_left {
	background-color: #fff94e75;
	min-height: 160px;
}

/*底部*/
#crypto .bottom {
	height: 50px;
	border-radius: 5px;
	border: 1px solid #0e78c7;
	margin: 20px 0px 0 0px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.oranges {
	color: #f1a104;
	font-size: 22px;
	margin-right: 20px;
}

.boranges {
	color: #c29328;
}

.bottom_ts {
	text-align: left;
}

/*没有虛擬錢包的*/
.none_card {
	text-align: center;
	font-size: 14px;
	color: #666;
}

.none_card_box {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 40px auto;
	color: #666;
}

.none_card .blue {
	padding: 8px 23px;
}

.bindCart .el-select {
	width: 100%;
}

.bindCart {
	margin-top: 20px;
	width: 50%;
}

/*表格样式*/
#crypto .el-dialog__body {
	padding: 0;
}

#crypto .el-dialog__footer {
	padding: 25px 0 60px;
	text-align: center;
}

#crypto .crypto_top {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 150px;
	position: relative;
}

#crypto .add_title {
	width: 204px;
	height: 130px;
	margin-top: 10px;
	border-right: solid 1px #dddddd;
}

#crypto .add_title > img {
	display: block;
	width: 72px;
	height: 70px;
	margin: 10px auto 0;
	cursor: pointer;
}

#crypto .add_title > a {
	display: block;
	width: 106px;
	height: 28px;
	margin: 13px auto 0;
	background-color: #d86556;
	font-size: 12px;
	color: #ffffff;
	text-align: center;
	line-height: 28px;
	border-radius: 14px;
	cursor: pointer;
}

#crypto .wxts {
	font-size: 16px;
	color: #333;
}

#crypto .crypto_top .list {
	font-size: 14px;
	color: #666;
	line-height: 16px;
}

#crypto .wxts_text {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	height: 116px;
	width: 100%;
	padding-top: 10px;
}

#crypto .tips_bind {
	width: 22px;
	height: 22px;
	margin-left: 20px;

	.el-icon-warning-outline {
		font-size: 22px;
		color: #1e8edd;
	}
}
#crypto .bottom_ts_text {
	color: #0e78c7;
	font-size: 14px;
	font-weight: bold;
	margin-left: 28px;
}

#crypto .bottom_top {
	display: flex;
	align-items: center;

	.blue {
		margin-left: 10px;

		font-size: 14px;
		color: blue;
		text-decoration: underline;
		cursor: pointer;
	}
}
.lock {
	display: flex;
	justify-content: left;
	align-items: center;
	padding-left: 20px;
	font-size: 13px;
	.btn {
		display: inline-block;
		width: 110px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		border: 1px solid #b0965d;
		font-size: 12px;
		font-weight: bold;
		border-radius: 3px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
		color: #fff;
		background: linear-gradient(to bottom, #b0965d 0, #b0965d 100%);
	}
	.lock_hint {
		margin-left: 10px;
		color: #666;

		a {
			text-decoration: none;
			color: #b0965d;
		}
	}
}
#crypto .notice {
	padding: 8px 10px;
	margin-bottom: 10px;
	border: 1px solid #f8e2b9;
	background-color: #fffdeb;
	color: #fb911f;
	font-size: 13px;
	span {
		margin-right: 8px;
	}
}
a.blue {
	margin-left: 10px;
	margin-right: 10px;
	font-size: 14px;
	color: blue;
	text-decoration: underline;
	cursor: pointer;
	font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/UserComps/crypto.vue